module.exports = __webpack_public_path__ + "img/Josh.df9598f7.jpg";